import {useLingui} from '@lingui/react/macro';
import {Fragment} from 'react';
import {Text, View, StyleSheet} from 'react-native';
import {colors} from 'config/styles';

export interface FileListHeaderProps {
  name: string;
  showColumns?: boolean;
}

export function FileListHeader(props: FileListHeaderProps) {
  const {t} = useLingui();
  return (
    <View style={styles.root}>
      <Text style={[styles.text, styles.name]}>
        {props.name.toUpperCase()}
      </Text>
      {props.showColumns &&
        <Fragment>
          <Text style={[styles.text, styles.size]}>
            {t`Details`.toUpperCase()}
          </Text>
          <Text style={[styles.text, styles.modified]}>
            {t`Modified`.toUpperCase()}
          </Text>
        </Fragment>
      }
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 14,
  },
  text: {
    fontSize: 10,
    fontWeight: '600',
  },
  name: {
    flex: 2,
    marginRight: 134,
    color: colors.neutral.darkgrey,
  },
  size: {
    flex: 1,
    color: colors.neutral.darkgrey,
  },
  modified: {
    flex: 1,
    marginRight: 92,
    color: colors.neutral.darkgrey,
  },
});
